<div class="user__menu-button" (click)="_toolsService.toggleMenu($event)">
  @if(!user()){
    <svg width="32" height="32" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="profleTitle">
      <title id="profleTitle">{{'Mi panel' | translate}}</title>
      <path d="M25.0772 23.3719C26.4236 21.752 27.36 19.8316 27.8072 17.7733C28.2544 15.7149 28.1993 13.5792 27.6466 11.5466C27.0938 9.51408 26.0596 7.64457 24.6316 6.09624C23.2035 4.54791 21.4235 3.36631 19.4421 2.6514C17.4608 1.93649 15.3364 1.7093 13.2487 1.98905C11.161 2.2688 9.17139 3.04726 7.44817 4.25858C5.72495 5.46989 4.31883 7.07843 3.34874 8.94811C2.37866 10.8178 1.87316 12.8936 1.87501 15C1.87571 18.062 2.95477 21.026 4.92282 23.3719L4.90407 23.3878C4.96969 23.4665 5.04469 23.534 5.11219 23.6119C5.19657 23.7084 5.28751 23.7994 5.37469 23.8931C5.63719 24.1781 5.90719 24.4519 6.19032 24.7087C6.27657 24.7875 6.36563 24.8606 6.45282 24.9356C6.75282 25.1944 7.06126 25.44 7.38094 25.6687C7.42219 25.6969 7.45969 25.7334 7.50094 25.7625V25.7512C9.69667 27.2964 12.316 28.1257 15.0009 28.1257C17.6858 28.1257 20.3052 27.2964 22.5009 25.7512V25.7625C22.5422 25.7334 22.5788 25.6969 22.6209 25.6687C22.9397 25.439 23.2491 25.1944 23.5491 24.9356C23.6363 24.8606 23.7253 24.7865 23.8116 24.7087C24.0947 24.4509 24.3647 24.1781 24.6272 23.8931C24.7144 23.7994 24.8044 23.7084 24.8897 23.6119C24.9563 23.534 25.0322 23.4665 25.0978 23.3869L25.0772 23.3719ZM15 7.49998C15.8344 7.49998 16.65 7.7474 17.3438 8.21097C18.0376 8.67453 18.5783 9.33341 18.8976 10.1043C19.2169 10.8752 19.3005 11.7234 19.1377 12.5418C18.9749 13.3601 18.5731 14.1118 17.9831 14.7018C17.3931 15.2918 16.6414 15.6936 15.823 15.8564C15.0047 16.0192 14.1564 15.9357 13.3856 15.6163C12.6147 15.297 11.9558 14.7563 11.4922 14.0625C11.0287 13.3688 10.7813 12.5531 10.7813 11.7187C10.7813 10.5998 11.2257 9.52679 12.0169 8.73562C12.8081 7.94445 13.8811 7.49998 15 7.49998ZM7.50657 23.3719C7.52283 22.1409 8.02308 20.9658 8.89909 20.1009C9.7751 19.2359 10.9564 18.7506 12.1875 18.75H17.8125C19.0436 18.7506 20.2249 19.2359 21.1009 20.1009C21.9769 20.9658 22.4772 22.1409 22.4934 23.3719C20.4374 25.2247 17.7677 26.25 15 26.25C12.2323 26.25 9.56265 25.2247 7.50657 23.3719Z" fill="#717171"/>
    </svg>
  }

  @if(user()){
    <span class="user-icon">
      {{ getUserIconLetter() }}
    </span>
  }

</div>

@if(!user()){
  <ul class="user__menu" [ngClass]="{'user__menu--is-active': _toolsService.menuIsShown}">
     @if(passportEnabled()){
      <li (click)="login()">{{'Pasaporte digital' | translate}}</li>
     }
    <li (click)="register()">{{'Regístrate' | translate}}</li>
    <li (click)="login()">{{'Inicia sesión' | translate}}</li>
  </ul>
}

@if(user()){
  <ul class="user__menu" [ngClass]="{'user__menu--is-active': _toolsService.menuIsShown}">
    <li><a routerLink="/my-account/favourites">{{'Favoritos' | translate}}</a></li>
    @if(showSavedRoutes()){
      <li><a routerLink="/my-account/saved-routes">{{'Mis rutas' | translate}}</a></li>
    }
    <!-- <li><a routerLink="/my-account/ticket-validation">{{'Validación de entradas' | translate}}</a></li> -->
    @if(passportEnabled()){
      <li><a routerLink="/my-account/passports">{{'Pasaporte digital' | translate}}</a></li>
    }
    <li class="user__menu-divider"></li>
    <li><a routerLink="/my-account">{{'Cuenta' | translate}}</a></li>
    <li (click)="logout()">{{'Cerrar sesión' | translate}}</li>
  </ul>
}

